<template>
        <img :class="classes" :src="src" :alt="alt" @error="replaceWithFallback"/>
</template>

<script>
export default {
    name: 'CdnImage',
    props: {
        src: String,
        fallbackSrc: String,
        alt: String,
        classes: String,
    },
    methods: {
        replaceWithFallback(e) {
            e.target.src = this.fallbackSrc;
        }
    }
}
</script>

<style lang="scss" scoped>

</style>